// extracted by mini-css-extract-plugin
export default {"alertWrapper":"BNYqVcR10tXCuTUp5Znm","icon":"hTPLRnLR4ts7B8h8hjCw"};